import { Routes } from '@angular/router';

export const THEMATICS_ROUTES: Routes = [
  {
    path: 'thematic/:uuid',
    loadComponent: () => import('./thematic.component').then(m => m.ThematicComponent)
  }
];
